import { Divider, Blockquote, Grid, Paper, Group, Title, Text, Table, useMantineTheme, Button } from "@mantine/core";
import { Link, useSearchParams } from "react-router-dom";

import { styles } from "../../styles";
import { downloadExtract } from "src/api";
import { showError } from "src/utilities";
import { IconX } from "@tabler/icons-react";

export default function Extracts({
  extracts,
}: {
  extracts: {
    name: string;
    type: string;
    fileName: string;
    fileType: string;
    details: any;
  }[];
}) {
  const theme = useMantineTheme();
  let [searchParams] = useSearchParams();

  let id = searchParams.get("id"),
    entityId = searchParams.get("entityId");

  if (extracts && extracts.length > 0) {
    return (
      <Grid align="flex-start" gutter={"xs"} columns={12}>
        <Table verticalSpacing="xs" fs={"xs"} withRowBorders={false}>
          <Table.Tbody>
            {extracts.length === 0 ? (
              <Table.Tr key={"NO-DATA"}>
                <Table.Td>
                  <Divider label="No Extracts" labelPosition="left" />
                </Table.Td>
                <Table.Td>-</Table.Td>
              </Table.Tr>
            ) : (
              <>
                {extracts.map((extract) => {
                  return (
                    <Table.Tr key={extract.fileName}>
                      <Table.Td>
                        <Button
                          variant="default"
                          onClick={async (event: React.MouseEvent<HTMLButtonElement>) => {
                            event.preventDefault();
                            try {
                              const response = await downloadExtract(id, entityId, extract.fileName);
                              if (response.status === 500) {
                                showError(
                                  "" as any,
                                  "Error in downloading file",
                                  "Error in downloading file",
                                  <IconX />,
                                );
                              }
                            } catch (error: any) {
                              showError(error, "Error in downloading file", "Error in downloading file", <IconX />);
                            }
                          }}
                        >
                          {extract.fileName}
                        </Button>
                      </Table.Td>
                    </Table.Tr>
                  );
                })}
              </>
            )}
          </Table.Tbody>
        </Table>
      </Grid>
    );
  } else {
    return <Divider label="No Extracts" labelPosition="left" />;
  }
}
